import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Showroom360 from "./pages/Showroom360";
import Blog from "./pages/Blog";

// Set PUBLIC_URL (frontend/.env) to a path such as "/kseinc" to serve the site
// from a sub-folder. Empty when hosted at the domain root.
const basename = (process.env.PUBLIC_URL || "").replace(/^https?:\/\/[^/]+/, "");

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/showroom" element={<Showroom360 />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
